<template>
  <ProductContentDetails
    headline="Kompatibilität"
    :offer="offer"
    class="compatible-product-families"
  >
    <template #default="slotProps">
      <CheckmarkRow
        v-for="(compatibleFamily, index) in slotProps.product.family.compatibleFamilies"
        :key="index"
        :checkmark-text="compatibleFamily.model"
      />
    </template>
  </ProductContentDetails>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import CheckmarkRow from '~/components/checkmark-row.vue';
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';
import type { Offer } from '~/lib/goliath/offer-by-slugs';

export default defineComponent({
  name: 'CompatibleProductFamilies',
  components: {
    CheckmarkRow,
    ProductContentDetails,
  },
  props: {
    offer: {
      type: Object as PropType<Offer>,
      required: true,
    },
  },
});
</script>
